import React from 'react'
import { Link } from 'react-router-dom'

import './LoginPage.css'
function IndexPage() {

    return (
      
        <>   
        {/* <!-- Card Body --> */}
        <section className="main-login">
          <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-4 col_center'>
                    <div className='login'>
                      <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/LoginPage">
                          <div className="sidebar-brand-icon rotate-n-15">
                              <i className="fas fa-laugh-wink"></i>
                          </div>
                          <div className="sidebar-brand-text mx-3">Say Eagle</div>
                      </a>
                      <form>
                        <h1> SayEagle Property Manager Log in to your account</h1>
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Email</label>
                          <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                          <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputPassword1">Password</label>
                          <input type="password" className="form-control" id="exampleInputPassword1" />
                        </div>
                        {/* <div className="form-group form-check">
                          <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                          <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                        </div> */}
                        <Link  to='/UserPhoneVerification' className="btn btn-primary submit">Submit</Link> 
                        <a href='/'>Forgot Password?</a>
                      </form>
                    </div>
                    <div className='row'>
                      <div className='col-lg-6 align_center'>
                        <a href='/'>Access Resident Portal</a>
                      </div>
                      <div className='col-lg-6 align_center'>
                        <a href='/'>Access Owner Portal</a>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </section>
        </>

    )
}

export default IndexPage
